
let _ = require('../_.js');
let $ = jQuery;

// Example of generic notification

_.Notification_Alert = class Notification_Alert {

    notification = null;

    constructor(notification) {
        this.notification = notification;
    }

    async on_show() {
        // Should subscribe to whatever records are relevant here for monitoring the notification.
        // These should subscribe to:
        //      _.Lib_Notifications.handle_notification_update

        // Should open whatever dialog box is necessary to show this notification.
        await _.Modal.alert(this.notification.message);

        await _.Lib_Notifications.dismiss_notification(this.notification.id);
    }

    async on_update() {
        // Update related data about the notification in real time.
    }

    async on_hide() {
        // Should unsubscribe to all subs here, this will always be called when notification is dismissed
        // Should close any custom dialogs, however, the Notification class will call Modal.hide() anyway.
    }
}